import React, { Suspense } from 'react';
import { useAuth } from 'auth/context/AuthContext';
import ProviderNavbarMobile from 'components/navbar/ProviderNavbarMobileComponent';
import ProviderNavbarNotApprovedMobile from 'components/navbar/ProviderNavbarNotApprovedMobileComponent';
import { BaseLayout } from '../../layout/BaseLayout';
import { Outlet } from 'react-router-dom';
import { ProviderNavbar } from './ProviderNavbar';
import { FallbackLoader } from 'components/loaderComponent';

export const ProviderLayout: React.FC = () => {
  const { user, stripeSubscription } = useAuth();
  const isApprovedProvider = Boolean(
    user?.providerEnabled && stripeSubscription?.length,
  );

  return (
    <BaseLayout
      renderNavbar={({ openNavbarMobile }) => (
        <ProviderNavbar openNavbarMobile={openNavbarMobile} />
      )}
      renderMobileNavbar={({ closeNavbarMobile }) =>
        isApprovedProvider ? (
          <ProviderNavbarMobile closeNavbarMobile={closeNavbarMobile} />
        ) : (
          <ProviderNavbarNotApprovedMobile
            closeNavbarMobile={closeNavbarMobile}
          />
        )
      }
    >
      <Suspense fallback={<FallbackLoader />}>
        <Outlet />
      </Suspense>
    </BaseLayout>
  );
};

export default ProviderLayout;
